export default "__VITE_ASSET__Dm1jfgTz__"